/**
 * Fabric.js v7 patch: skip objects an animation has scaled to nothing.
 *
 * Presets stand in `MIN_ANIMATION_SCALE` for a zero scale (a true zero breaks
 * Fabric's cache), and hold it until their block starts. Fabric still renders
 * such an object every frame: a video waiting to scale in redraws its frame
 * and both of its clips into a full cache canvas, for a dot a tenth of a pixel
 * wide. An object at that scale on either axis shows nothing, unless it keeps
 * a stroke whose width ignores scale, so it is not drawn at all.
 */
import { FabricObject, Group } from 'fabric';
import { MIN_ANIMATION_SCALE } from '@/constants/animation';

const render = FabricObject.prototype.render;

FabricObject.prototype.render = function (
  this: FabricObject,
  ctx: CanvasRenderingContext2D
) {
  if (isScaledAway(this)) return;
  render.call(this, ctx);
};

function isScaledAway(obj: FabricObject): boolean {
  return (
    (Math.abs(obj.scaleX) <= MIN_ANIMATION_SCALE ||
      Math.abs(obj.scaleY) <= MIN_ANIMATION_SCALE) &&
    !keepsUniformStroke(obj)
  );
}

function keepsUniformStroke(obj: FabricObject): boolean {
  if (obj.strokeUniform && obj.hasStroke()) return true;
  return obj instanceof Group && obj.getObjects().some(keepsUniformStroke);
}
